import React from "react";
import PropTypes from 'prop-types';
import StyledTreeItem from "../MenuDesignerNew/MenuItemsProperties/MenuItems/StylesMenuItem";

const SideBarTree = (props) => {
    const {
        menu, arrayPath, onKeyDownItem, level = 0,
        screenName, dropdownItemStyles, mobileMenu,
        doActions, menuStyles, actionContext, closedCompact, isOpenDrawer
    } = props;
    return (
        menu.map((menuItem, index) => {
            const hasChildren = Boolean(menuItem.sub);
            const itemProperties = menuItem.properties ? menuItem.properties : menuItem;
            let itemPath = arrayPath ? `${arrayPath}.${index}` : `${index}`;
            const containerItemStyles = menuItem.styles ? menuItem.styles[1] || {} : {};
            let itemStyles = menuItem.styles ?
                [{...dropdownItemStyles, ...menuItem.styles[0]}, {...containerItemStyles}] :
                [dropdownItemStyles]
            if (hasChildren) {
                return (
                    <StyledTreeItem
                        nodeId={itemPath} key={itemPath} labelText={itemProperties.label}
                        labelIcon={itemProperties.icon} iconType={itemProperties.iconType} level={level}
                        styles={mobileMenu ? itemStyles[mobileMenu]: itemStyles}
                        events={menuItem.events}
                        badge={itemProperties.badgeValue}
                        screenName={screenName}
                        doActions={doActions}
                        menuStyles={menuStyles}
                        disabledCondition={itemProperties.disabledCondition}
                        actionContext={actionContext}
                        closedCompact={closedCompact}
                        isOpenDrawer={isOpenDrawer}
                    >
                        {SideBarTree({
                            menu: menuItem.sub,
                            arrayPath: `${itemPath}.sub`,
                            onKeyDownItem,
                            level: level + 1,
                            screenName,
                            dropdownItemStyles,
                            mobileMenu,
                            menuStyles,
                            doActions,
                            actionContext,
                            closedCompact, isOpenDrawer
                        })}
                    </StyledTreeItem>
                )
            }
            return (
                <StyledTreeItem
                    id={`sidebar_${itemPath}`}
                    key={itemPath}
                    level={level}
                    nodeId={itemPath}
                    onKeyDown={(e) => onKeyDownItem(e, itemPath, true)}
                    labelText={itemProperties.label}
                    labelIcon={itemProperties.icon}
                    iconType={itemProperties.iconType}
                    styles={mobileMenu ? itemStyles[mobileMenu]: itemStyles}
                    events={menuItem.events}
                    badge={itemProperties.badgeValue}
                    screenName={screenName}
                    doActions={doActions}
                    menuStyles={menuStyles}
                    disabledCondition={itemProperties.disabledCondition}
                    actionContext={actionContext}
                    closedCompact={closedCompact}
                    isOpenDrawer={isOpenDrawer}
                />
            )
        })
    )
};
export default SideBarTree

SideBarTree.propTypes = {
    menu: PropTypes.array.isRequired,
    arrayPath: PropTypes.string
};